import resizeVideos from './resizeVideos';
import autoPauseResume from './autoPauseResume';
import themeEditor from './themeEditor';
import { native_players, nativePlayerInit } from './nativePlayer';
import { youtube_players, youtubePlayerInit } from './youtubePlayer';
import { vimeo_players, vimeoPlayerInit } from './vimeoPlayer';

const BackgroundVideo = () => {
  // NATIVE MP4
  document.querySelectorAll('[data-background-video][data-video-type="native"]').forEach((container) => {
    nativePlayerInit(container);
  });

  // VIMEO
  document.querySelectorAll('[data-background-video][data-video-type="vimeo"]').forEach((container) => {
    vimeoPlayerInit(container);
  });

  window.addEventListener('scroll', () => {
    autoPauseResume(native_players, 'native');
    autoPauseResume(vimeo_players, 'vimeo');
  });

  document.addEventListener('heroCarouselDidChange', () => {
    autoPauseResume(native_players, 'native');
    autoPauseResume(vimeo_players, 'vimeo');
  });

  // ALL VIDEOS

  window.addEventListener('resize', () => {
    resizeVideos();
  });

  themeEditor();

  // YOUTUBE
  // This should have been clean and just like the above, but we have to do this dirty shit with window.onYouTubePlayerAPIReady
  // since there isn't a nice ES6 way of properly using the youtube iframe API.  All the npm modules out there suck.
  let api_ready_fired = false;

  window.onYouTubePlayerAPIReady = () => {
    api_ready_fired = true;

    document.querySelectorAll('[data-background-video][data-video-type="youtube"]').forEach((container) => {
      youtubePlayerInit(container);
    });

    window.addEventListener('scroll', () => {
      autoPauseResume(youtube_players, 'youtube');
    });

    document.addEventListener('heroCarouselDidChange', () => {
      autoPauseResume(youtube_players, 'youtube');
    });
  };

  // YouTube fires this automatically when it loads, but if youtube loads before us, we'll fire it
  if (window.YT && window.YT.Player && !api_ready_fired) {
    window.onYouTubePlayerAPIReady();
  }
};

export { BackgroundVideo };
